module.exports = __webpack_public_path__ + "media/banner/banner-2-b1bd4ad2.jpg";